/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React from 'react';

import { I18n } from '@aws-amplify/core';

import { makeStyles } from '@material-ui/core/styles';

import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem'
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import useWindowDimensions from '../../components/ViewPort/useWindowDimensions';
import fallbackLogo from '../../assets/Logos/fallback-logo.png';


const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-around',
		overflow: 'hidden',
		marginBottom: 40,
	},
	gridList: {
		width: '90%',
		justifyContent: 'center',
		margin: '0px',
	},
	buttonItem: {
		margin: theme.spacing(2),
	},
}));

export default function AppTiles(props) {
	const classes = useStyles();

	/*
	 * get the width of the viewport
	 * the total width of a tile
	 * set the count of Columns in the grid
	 */
	const { width } = useWindowDimensions();
	const tileTotalWidth = 350;
	const gridCols = () => {
		return (width / tileTotalWidth)
	};

	/*
	* if no Client Logo available load 'default.png'
	*/
	const fallBackImage = fallbackLogo;

	return (
		<div className={classes.root}>
			<ImageList cols={gridCols()} className={classes.gridList}>
				{props.appClients.map((tile) => (
					<ImageListItem key={tile.client_id} >
						<img
							src={tile.client_logo || fallBackImage}
							onError={(e) => { e.target.onerror = null; e.target.src = fallBackImage; }}
							alt={tile.client_name + " " + I18n.get('DASHBOARD_APPTILES_LOGO')}
						/>

						<ImageListItemBar
							title={tile[`client_name_${props.lang}`]}
							className={classes.listItem}
							actionIcon={
								<Button
									variant="contained"
									href={tile.logback_uri}
									color="secondary"
									className={classes.buttonItem}
								>
									{I18n.get("DASHBOARD_APPTILES_BTN_OPEN")}
								</Button>
							}
						/>
					</ImageListItem>
				))}
			</ImageList>
		</div >
	);
}
